import script from "./ItemWithDesc.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemWithDesc.vue?vue&type=script&setup=true&lang=js"

import "./ItemWithDesc.vue?vue&type=style&index=0&id=ebd23604&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebd23604"]])

export default __exports__